namespace Gamification.Gamification {

    @Serenity.Decorators.maximizable()
    @Serenity.Decorators.registerClass()
    export class RisorsePickerDialog extends Serenity.TemplatedDialog<RisorsePickerOptions> {

        private checkGrid: RisorseCheckGrid;

        constructor(opt: RisorsePickerOptions) {
            super(opt);

            this.checkGrid = new RisorseCheckGrid(this.byId("CheckGrid"), opt);
            this.dialogTitle = "Seleziona le risorse desiderate";
        }

        protected getTemplate() {
            return `<div id="~_CheckGrid"></div>`;
        }

        protected getDialogButtons() {
            return [
                {
                    text: Q.text("Dialogs.OkButton"),
                    click: () => {
                        var selected = this.checkGrid.selectedItems;
                        if (!selected.length) {
                            Q.notifyWarning("Seleziona almeno un elemento!");
                            return;
                        }

                        if (!this.onSuccess || this.onSuccess(selected))
                            this.dialogClose();
                    }
                },
                {
                    text: Q.text("Dialogs.CancelButton"),
                    click: () => {
                        this.dialogClose();
                    }
                }
            ];
        }

        get selectedItems() {
            return this.checkGrid.selectedItems;
        }

        public onSuccess: (selected: Gamification.RisorseRow[]) => boolean;
    }
}